import React, { useEffect } from "react";
import { trackVisit } from "@/lib/analytics";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Stays from "@/components/Stays";
import Fishing from "@/components/Fishing";
import Facilities from "@/components/Facilities";
import Booking from "@/components/Booking";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Location from "@/components/Location";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const REF_STORAGE_KEY = "wl.referralCode";
const REF_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

const LandingPage = () => {
  useEffect(() => {
    trackVisit(window.location.pathname);
  }, []);

  useEffect(() => {
    // Deep links like /?pitch=daisy-hs-05&…#book: the browser's native anchor
    // jump fires before React renders anything, so it never finds #book and
    // the guest lands on the hero. Scroll to the booking section ourselves
    // once the page has painted and started to settle.
    if (window.location.hash !== "#book") return;
    let tries = 0;
    const scroll = () => {
      const el = document.getElementById("book");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      else if (++tries < 10) setTimeout(scroll, 200);
    };
    const t = setTimeout(scroll, 300);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    // Capture ?ref=CODE from URL and stash it in localStorage so the Booking form
    // can auto-apply the friend-referral discount even if the user browses away first.
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (ref && ref.length <= 40) {
        window.localStorage.setItem(
          REF_STORAGE_KEY,
          JSON.stringify({ code: ref.toUpperCase(), savedAt: Date.now() }),
        );
      } else {
        // Purge stale referral codes older than 30 days.
        const raw = window.localStorage.getItem(REF_STORAGE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (!parsed?.savedAt || Date.now() - parsed.savedAt > REF_TTL_MS) {
            window.localStorage.removeItem(REF_STORAGE_KEY);
          }
        }
      }
    } catch {
      // ignore — localStorage may be disabled
    }
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#F5EFE6]">
      <Seo path="/" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Stays />
        <Fishing />
        <Facilities />
        <Booking />
        <Gallery />
        <Reviews />
        <Location />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
